import Repository from '@/repositories/marketing'
const feedTemplateResource = '/product_feed_templates'

export default {
  /**
   * @use Product Feed Templates index UI
   */
  fetch (config) {
    return Repository.get(`${feedTemplateResource}.json`, config)
  },
  /**
   * @use Product Feed Templates index UI
   */
  /**
   * @use Product Feed Editor START
   */
  create (data, config) {
    return Repository.post(`${feedTemplateResource}.json`, data, config)
  },
  show (feedTemplateId, config) {
    return Repository.get(`${feedTemplateResource}/${feedTemplateId}.json`, config)
  },
  update (feedTemplateId, data, config) {
    return Repository.put(`${feedTemplateResource}/${feedTemplateId}.json`, data, config)
  },
  /**
   * @use Product Feed Editor END
   */
}
